"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchBaton = exports.retransmitBaton = exports.createBaton = exports.failBaton = exports.closeBatonById = exports.closeBatonByUrl = exports.getBatonByUrl = exports.getBatonById = exports.lockAndGetBatons = exports.getBatons = exports.getBatonClient = void 0;
const helpers_1 = require("../helpers");
const baton_1 = require("../models/baton");
const getBatonClient = ({ accessToken, env = baton_1.BatonEnv.PRODUCTION, options: globalOptions }) => {
    // Reuse these values for all requests
    const userAccessToken = accessToken;
    const environment = env;
    return {
        getBatons: async (options) => {
            return (0, exports.getBatons)(userAccessToken, Object.assign(Object.assign({}, globalOptions), options), environment);
        },
        lockAndGetBatons: async (options) => {
            return (0, exports.lockAndGetBatons)(userAccessToken, Object.assign(Object.assign({}, globalOptions), options), environment);
        },
        getBatonById: async (batonId) => {
            return (0, exports.getBatonById)(userAccessToken, batonId, globalOptions, environment);
        },
        getBatonByUrl: async (batonUrl) => {
            return (0, exports.getBatonByUrl)(userAccessToken, batonUrl, globalOptions, environment);
        },
        closeBatonById: async (batonId, transmissionExecutionDetails) => {
            return (0, exports.closeBatonById)(userAccessToken, batonId, transmissionExecutionDetails, globalOptions, environment);
        },
        closeBatonByUrl: async (batonUrl, transmissionExecutionDetails) => {
            return (0, exports.closeBatonByUrl)(userAccessToken, batonUrl, transmissionExecutionDetails, globalOptions, environment);
        },
        createBaton: async (postRequestBody) => {
            return (0, exports.createBaton)(userAccessToken, postRequestBody, globalOptions, environment);
        },
        retransmitBaton: async (batonId) => {
            return (0, exports.retransmitBaton)(userAccessToken, batonId, globalOptions, environment);
        },
        failBaton: async (batonUrl, transmissionExecutionDetails) => {
            return (0, exports.failBaton)(userAccessToken, batonUrl, transmissionExecutionDetails, globalOptions, environment);
        },
        patchBaton: async (batonUrl, patchBatonRequest) => {
            return (0, exports.patchBaton)(userAccessToken, batonUrl, patchBatonRequest, globalOptions, environment);
        },
    };
};
exports.getBatonClient = getBatonClient;
const getBatons = async (accessToken, options, env = baton_1.BatonEnv.PRODUCTION) => {
    var _a;
    const client = (0, helpers_1.getClientInstance)(options);
    const config = {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        params: {
            transmissionMethodKey: options.transmissionMethodKey,
            transmissionConfigurationId: options.transmissionConfigurationId,
            status: options.status,
            actionType: options.actionType,
            offset: options.offset,
            limit: options.limit,
            tag: options.tag,
            fulfillmentGroupId: options.fulfillmentGroupId,
            createdAtAfter: options.createdAtAfter,
            createdAtBefore: options.createdAtBefore,
            transmissionGroupKey: (_a = options.transmissionGroupKey) === null || _a === void 0 ? void 0 : _a.join(',')
        }
    };
    return (await client.get(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons`, config)).data;
};
exports.getBatons = getBatons;
const lockAndGetBatons = async (accessToken, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const client = (0, helpers_1.getClientInstance)(options);
    return (await client.post(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons:lock`, {
        transmissionMethodKey: options.transmissionMethodKey,
        actionType: options.actionType,
        limit: options.limit,
        lockDuration: options.lockDuration
    }, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })).data;
};
exports.lockAndGetBatons = lockAndGetBatons;
const getBatonById = async (accessToken, batonId, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const client = (0, helpers_1.getClientInstance)(options);
    return (await client.get(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons/${batonId}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })).data;
};
exports.getBatonById = getBatonById;
const getBatonByUrl = async (accessToken, batonUrl, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const batonId = batonUrl.split(/[/]+/).pop();
    if (!batonId) {
        throw new Error(`Could not get the Baton. Invalid URL passed (${batonUrl})`);
    }
    return (0, exports.getBatonById)(accessToken, batonId, options, env);
};
exports.getBatonByUrl = getBatonByUrl;
const closeBatonByUrl = async (accessToken, batonUrl, transmissionExecutionDetails, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const client = (0, helpers_1.getClientInstance)(options);
    const batonId = batonUrl.split(/[/]+/).pop();
    if (!batonId) {
        throw new Error(`Could not close the Baton. Invalid URL passed (${batonUrl})`);
    }
    return (await client.post(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons/${batonId}:closeBaton`, transmissionExecutionDetails, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })).data;
};
exports.closeBatonByUrl = closeBatonByUrl;
const closeBatonById = async (accessToken, batonId, transmissionExecutionDetails, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const client = (0, helpers_1.getClientInstance)(options);
    return (await client.post(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons/${batonId}:closeBaton`, transmissionExecutionDetails, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })).data;
};
exports.closeBatonById = closeBatonById;
const failBaton = async (accessToken, batonUrl, transmissionExecutionDetails, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const client = (0, helpers_1.getClientInstance)(options);
    const batonId = batonUrl.split(/[/]+/).pop();
    if (!batonId) {
        throw new Error(`Could not close the Baton. Invalid URL passed (${batonUrl})`);
    }
    return (await client.post(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons/${batonId}:failBaton`, transmissionExecutionDetails, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })).data;
};
exports.failBaton = failBaton;
const createBaton = async (accessToken, postRequestBody, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const client = (0, helpers_1.getClientInstance)(options);
    return (await client.post(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons`, postRequestBody, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })).data;
};
exports.createBaton = createBaton;
const retransmitBaton = async (accessToken, batonId, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const client = (0, helpers_1.getClientInstance)(options);
    return (await client.post(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons/${batonId}:retransmit`, {}, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })).data;
};
exports.retransmitBaton = retransmitBaton;
const patchBaton = async (accessToken, batonUrl, patchBaton, options, env = baton_1.BatonEnv.PRODUCTION) => {
    const client = (0, helpers_1.getClientInstance)(options);
    const batonId = batonUrl.split(/[/]+/).pop();
    return (await client.patch(`${(0, helpers_1.getBatonBaseUrl)(env)}/v2/batons/${batonId}`, patchBaton, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })).data;
};
exports.patchBaton = patchBaton;
